import { useRouter } from 'next/router'

const useCompanyOpenDetails = () => {
  const router = useRouter()

  const openFor = (id : number) => {
    router.push('/company-detail/' + id)
  }

  return { openFor }
}

export default useCompanyOpenDetails
